<mat-tree [dataSource]="nodes()" [childrenAccessor]="childrenAccessor">

  <!-- Nœud feuille : niveau -->
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
    <app-icon type="do" icon="niveau-musical" class="node-icon primary" size="18" style="margin-left: 20px;"></app-icon>
    {{ node.label }}
  </mat-tree-node>

  <!-- Nœud expansible : département ou discipline -->
  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding matTreeNodeToggle
    #treeNode="matTreeNode">
    <button mat-icon-button matTreeNodeToggle class="expand-icon-button" [attr.aria-label]="'Déplier ' + node.label">
      <mat-icon>{{ treeNode.isExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
    </button>
    <app-icon class="node-icon primary" type="do" [icon]="node.level === 0 ? 'departement' : 'discipline'"
      size="18"></app-icon>
    <span [class.dept-label]="node.level === 0">{{ node.label }}</span>
  </mat-tree-node>

</mat-tree>

<div class="tree-stats">
  <span><app-icon type="do" icon="departement" size="18" matTooltip="Département"></app-icon> {{ stats().depts }}</span>
  <span><app-icon type="do" icon="discipline" size="18" matTooltip="Discipline"></app-icon> {{ stats().disciplines
    }}</span>
  <span><app-icon type="do" icon="niveau-musical" size="18" matTooltip="Niveau"></app-icon> {{ stats().niveaux }}</span>
</div>